import {StyleSheet} from "aphrodite";
import * as React from "react";

import {View} from "@khanacademy/wonder-blocks-core";
import {MediaLayout} from "@khanacademy/wonder-blocks-layout";
import {color} from "@khanacademy/wonder-blocks-tokens";

export default function Divider(): React.ReactElement {
    return (
        <MediaLayout styleSheets={styleSheets}>
            {({styles}) => {
                return <View style={styles.divider} />;
            }}
        </MediaLayout>
    );
}

const styleSheets = {
    mdOrLarger: StyleSheet.create({
        divider: {
            height: 1,
            width: "100%",
            maxWidth: 1120,
            backgroundColor: color.offBlack16,
            margin: "0 auto",
        },
    }),
    small: StyleSheet.create({
        // Note(nisha): The following styles are used. The linter is confused
        // on the last style so we have to disable eslint.
        // eslint-disable-next-line react-native/no-unused-styles
        divider: {
            display: "none",
        },
    }),
} as const;
